export const SectionLabel = ({ number, children, className = "" }) => (
  <div className={`font-mono-label text-[11px] font-semibold text-oath-accent ${className}`}>
    — {number} — <span className="text-oath-muted">{children}</span>
  </div>
);

export default SectionLabel;
